import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/OnboardingWizard/result/ResultRunwayHeroValue";
import type { FC } from "react";

const I18n = I18nUtil.createScoped(Translations);

const RUNWAY_MONTHS_PATTERN = /^(\d+)\s*mo$/i;

export function parseRunwayHeroMonths(value: string): number | null {
  const match = value.match(RUNWAY_MONTHS_PATTERN);
  if (!match) {
    return null;
  }
  return Number(match[1]);
}

interface ResultRunwayHeroValueProps {
  value: string;
}

/** Figma 96138:32116 — display_s digit + title_xxl "months" on shared baseline. */
export const ResultRunwayHeroValue: FC<ResultRunwayHeroValueProps> = ({
  value,
}) => {
  const months = parseRunwayHeroMonths(value);

  if (months == null) {
    return (
      <span
        className="display_s text-content_primary"
        data-testid="result-runway-hero-value"
      >
        {value}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-end gap-1.5"
      data-testid="result-runway-hero-value"
    >
      <span className="display_s text-content_primary">{months}</span>
      <span className="title_xxl text-content_primary">{I18n.t("months")}</span>
    </span>
  );
};
